import { Object3D, Vector3 } from "three";
import { SignalConfig } from "../../config/SignalConfig";
import { RoofAddon } from "../../scene/addon/RoofAddon";
import { MaterialManager } from "../../material/MaterialManager";

/**
 * Located at the end of the roof.
 * Disappear when gutter is used?
 */

export class EaveTrim
{

	private _parent : Object3D;
	private _pitch  : SignalConfig<number>;
	private _addon  : RoofAddon;

	constructor(parent:Object3D, pitch:SignalConfig<number>)
	{
		this._parent = parent;
		this._pitch  = pitch;
		this.init();
	}

	private init = () =>
	{
		var config = {
			"id": "",
			"label": "Low Profile Vent",
			"mesh": {
				"1": "#0810 - Sculptured Eave Trim - 1/12 Pitch",
				"2": "#0810 - Sculptured Eave Trim - 2/12 Pitch",
				"3": "#0810 - Sculptured Eave Trim - 3/12 Pitch",
				"4": "#0810 - Sculptured Eave Trim - 4/12 Pitch",
				"5": "#0810 - Sculptured Eave Trim - 4/12 Pitch"
			},
			"size": {
				"length": 0
			},
			"material": MaterialManager.getInstance().trim,
			"pitch": this._pitch
		};

		this._addon = new RoofAddon(config);

		this._addon.addToScene(this._parent);
		this._addon.show();
	};

	public update = (position: Vector3, length: number, pitch: number) =>
	{
		var container = this._addon.container;

		this._addon.updatePitch(undefined, pitch);

		container.rotation.y = Math.PI;

		container.position.x = position.x;
		container.position.y = position.y;
		container.position.z = position.z;

		// length = length + metrics.overhang_end * 2 - 0.8;

		// 200 is the scale of the children meshes (set in blender)
		container.scale.z = length / 200;
	};

	public show()
	{
		this._addon.show();
	}

	public hide()
	{
		this._addon.hide();
	}
}